import { Box, Button, TextField, Typography } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { useDataProvider, useNotify } from 'react-admin';
import parse from 'html-react-parser';
import './style.css';
import SubscriptionCard from './SubscriptionCard';
import { useSubscriptionModels } from './hooks/useSubscriptionModels';
import AddSubscriptionDialog from './AddSubscriptionDialog';
import SubscriptionsStatisticsTable from './subscriptionsStatisticTable';
import {
  SubscriptionStatisticTabs,
  GeneralTabsIds,
} from './SubscriptionStatisticTabs';

import moment from 'moment';
import Loader from '../common/loader';
import DateTimePicker from 'react-datetime-picker';
import CustomDateSelector from '../common/custom-date-selector';

const Subscriptions: FC = () => {
  const [dateState, setDateState] = useState({
    startAt: undefined,
    endsAt: undefined,
  });
  const dataProvider = useDataProvider();
  const {
    state,
    updateSubscription,
    addSubscription,
    addSubscriptionMonth,
    updateSubscriptionMonth,
  } = useSubscriptionModels();
  const notify = useNotify();

  const openNewTab = () => {
    window.open('https://www.sendtric.com/', '_blank', 'noopener,noreferrer');
  };

  let tabs = [
    {
      label: 'All',
      value: GeneralTabsIds.All,
      panel: <SubscriptionsStatisticsTable type={GeneralTabsIds.All} />,
    },
    {
      label: 'Standard',
      value: GeneralTabsIds.Standard,
      panel: <SubscriptionsStatisticsTable type={GeneralTabsIds.Standard} />,
    },
    {
      label: '3 Month',
      value: GeneralTabsIds.ThreeMonth,
      panel: <SubscriptionsStatisticsTable type={GeneralTabsIds.ThreeMonth} />,
    },
    {
      label: '6 Month',
      value: GeneralTabsIds.SixMonth,
      panel: <SubscriptionsStatisticsTable type={GeneralTabsIds.SixMonth} />,
    },
    {
      label: '12 Month',
      value: GeneralTabsIds.TwelveMonth,
      panel: <SubscriptionsStatisticsTable type={GeneralTabsIds.TwelveMonth} />,
    },
  ];

  async function getSubscriptionsStatisticReport(type, datesString) {
    const result = (await dataProvider.getSubscriptionStatisticsReport(
      type,
      datesString,
    )) as any;

    return result.data;
  }
  const [loading, setLoading] = useState(false);
  async function createSubscriptionStatisticsReport() {
    try {
      setLoading(true);
      if (dateState.startAt && dateState.endsAt) {
        const response = await dataProvider.createSubscriptionsReport({
          startDate: dateState.startAt,
          endDate: dateState.endsAt,
        });
      }
      notify(
        'Report started to generate, you can download it on report list',
        'info',
      );
    } catch (err) {
      console.error(err);
      notify(JSON.stringify(err), 'error');
    } finally {
      setLoading(false);
    }
  }
  async function generateExtendReport() {
    try {
      setLoading(true);
      let filterQuery = '';
      let reportQuery = '';
      if (dateState.startAt && dateState.endsAt) {
        filterQuery = `?startAt=${moment(dateState.startAt).format(
          'YYYY-MM-DD',
        )}&endsAt=${moment(dateState.endsAt).format('YYYY-MM-DD')}`;
        reportQuery = `from ${moment(dateState.startAt).format(
          'YYYY-MM-DD',
        )} to ${moment(dateState.endsAt).format('YYYY-MM-DD')}`;
      } else if (dateState.startAt && !dateState.endsAt) {
        filterQuery = `?startAt=${moment(dateState.startAt).format(
          'YYYY-MM-DD',
        )}`;
        reportQuery = `from ${moment(dateState.startAt).format(
          'YYYY-MM-DD',
        )} to now`;
      } else if (!dateState.startAt && dateState.endsAt) {
        filterQuery = `?endsAt=${moment(dateState.endsAt).format(
          'YYYY-MM-DD',
        )}`;
        reportQuery = `to ${moment(dateState.endsAt).format('YYYY-MM-DD')}`;
      }
      let blob = await getSubscriptionsStatisticReport('asdasd', filterQuery);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Subscriptions Report ${reportQuery}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      notify('Report created and started downloading', 'info');
    } catch (err) {
      console.error(err);
      notify(JSON.stringify(err), 'error');
    } finally {
      setLoading(false);
    }
  }

  function handleChangeStartAt(value) {
    setDateState((state) => {
      return { ...state, startAt: value };
    });
  }
  function handleChangeEndsAt(value) {
    setDateState((state) => {
      return { ...state, endsAt: value };
    });
  }
  function clearStartAt() {
    setDateState({
      ...dateState,
      startAt: undefined,
    });
  }
  function clearEndsAt() {
    setDateState({
      ...dateState,
      endsAt: undefined,
    });
  }
  return (
    <Box className='email-coupon-wrapper'>
      <Box>
        <Box>
          <AddSubscriptionDialog addSubscription={addSubscription} />
        </Box>
        <div className='subscription-statistics'>
          {/* <SubscriptionsStatisticsTable /> */}
          <h1>Subscription Statistics</h1>
          <Box
            alignItems={'center'}
            justifyContent={'space-between'}
            display={'flex'}
            marginBottom={'20px'}
          >
            <Box
              display={'flex'}
              alignItems={'center'}
              flexDirection={'column'}
            >
              <CustomDateSelector
                title='Start At'
                onReset={clearStartAt}
                onChange={handleChangeStartAt}
                value={dateState.startAt}
              />
              <CustomDateSelector
                title='Ends At'
                onReset={clearEndsAt}
                onChange={handleChangeEndsAt}
                value={dateState.endsAt}
              />
              {/* <Box
                display='flex'
                alignItems='center'
                justifyContent='flex-start'
              >

                <Box
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'flex-start'}
                >
                  <Typography gutterBottom className='base-color'>
                    Start date{' '}
                  </Typography>
                  <Typography
                    onClick={clearStartAt}
                    gutterBottom
                    className='base-color'
                  >
                    (Reset)
                  </Typography>
                </Box>

                <Box>
                  <DateTimePicker
                    // disabled={state.isActiveDreamHome}
                    value={dateState.startAt ? dateState.startAt : null}
                    format={'dd-MM-y'}
                    onChange={handleChangeStartAt}
                    maxDate={new Date('2051-01-18T19:55:00.000+00:00')}
                    minDate={new Date('2000-01-18T19:55:00.000+00:00')}
                    disableClock
                  />
                </Box>
              </Box> */}
            </Box>
            <Button
              variant='outlined'
              onClick={createSubscriptionStatisticsReport}
              disabled={loading}
            >
              {loading ? <Loader small loading={loading} /> : undefined}
              {loading ? 'wait...' : 'Generate and Download Report'}
            </Button>
          </Box>
          <SubscriptionStatisticTabs tabs={tabs} />
        </div>
        <div className='subscription-models-list'>
          {state.subscriptionModels.map((model: any, index) => {
            return (
              <SubscriptionCard
                key={model._id}
                data={model}
                updateSubscription={updateSubscription}
                updateMonth={updateSubscriptionMonth}
                addMonth={addSubscriptionMonth}
              />
            );
          })}
        </div>
      </Box>
    </Box>
  );
};

export default Subscriptions;
